// extracted by mini-css-extract-plugin
export default {"progressCompleted":"progressCompleted---BLaID","withErrors":"withErrors---qsGTW"};